import Bowser from 'bowser';
export const getWebUser = () => {
    let browser;
    let device;
    let platform;
    try {
        const parsed = Bowser.parse(navigator.userAgent);
        const { name: browserName, version: browserVersion } = parsed.browser;
        if (browserName) {
            const majorVersion = browserVersion === null || browserVersion === void 0 ? void 0 : browserVersion.split('.')[0];
            browser = majorVersion ? `${browserName} ${majorVersion}` : browserName;
        }
        const { model, type, vendor } = parsed.platform;
        const deviceLabel = model || type;
        if (deviceLabel) {
            device = vendor ? `${vendor} ${deviceLabel}` : deviceLabel;
        }
        const { name: osName, version: osVersion } = parsed.os;
        if (osName) {
            platform = osVersion ? `${osName} ${osVersion}` : osName;
        }
    }
    catch (_a) {
        // Bowser.parse() throws on empty/null user agent strings.
        // Fall through with undefined browser/device/platform.
    }
    return {
        language: navigator.language.split(',')[0],
        locales: navigator.languages,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        browser,
        device,
        platform,
    };
};
